/**
 * Login Saga
 *
 * Handles the authentication flow using Redux-Saga:
 * 1. Receives login credentials (phone + password) from the dispatch
 * 2. Encrypts credentials using AES-CBC before sending to API
 * 3. Dispatches success/failure actions based on API response
 */
import { takeLatest, put, call } from 'redux-saga/effects';
import LoginTypes from './login.types';
import { login } from './login.services';
import { loginSuccess, loginFailure } from './login.action';
import { encryptData } from '../_common/enode-decode';

/**
 * Login saga worker - encrypts credentials and calls the login API.
 * On success, dispatches loginSuccess with encrypted response data.
 * On failure, dispatches loginFailure with error message.
 */
export function* loginSaga(payload: any) {
	try {
		// Extract credentials from the dispatched action payload
		const LoginDetailsToken = {
			userPhone: payload.payload.userPhone,
			userPassword: payload.payload.userPassword,
		};
		// Encrypt credentials before sending to the API
		const encryptedData = encryptData(LoginDetailsToken, LoginTypes.LOGIN_KEY);
		// @ts-ignore
		const responseData = yield call(login as any, encryptedData);
		if (responseData.data.status === 'success') {
			yield put(loginSuccess(responseData.data));
		} else {
			yield put(loginFailure(responseData.data));
		}
	} catch (error: any) {
		yield put(loginFailure(error?.response?.data?.message || 'An error occurred'));
	}
}

/** Watcher saga - listens for LOGIN_START actions and triggers loginSaga */
export function* onLoginStart(): Generator<any, void, any> {
	yield takeLatest(LoginTypes.LOGIN_START as any, loginSaga);
}

/** Root login saga - initializes the login watcher */
export function* loginSagaDetails(): Generator<any, void, any> {
	yield call(onLoginStart);
}
